module.exports = __webpack_public_path__ + "img/la_fontaine.b41313fc.jpg";